<nb-card class="cv-hub-card" [class.cv-hub-card--standard]="mode === 'standard'">
  <nb-card-header class="cv-hub-header">
    <span>{{ 'cv.hub.title' | translate }}</span>
    <button nbButton ghost status="basic" size="small" (click)="close()"
            [attr.aria-label]="'cv.generate.close' | translate">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    @if (mode === 'tiles') {
      @if (!pickedUserId) {
        <div class="cv-hub-pick-user">
          <span class="cv-hub-pick-label">{{ 'cv.hub.pickConsultant' | translate }}</span>
          <bst-list-adder size="small" status="basic"
            [placeholder]="'cv.client.pickUser' | translate"
            [listTemplate]="userlisttemplate" [autolist]="true"
            [formControl]="userControl" [single]="true"
            [filters]="{logo: true}" [target]="'member'">
          </bst-list-adder>
        </div>
      }
      <div class="cv-hub-tiles">
        @if (!auth.isUser) {
          <button class="cv-hub-tile tile-standard" type="button" (click)="pick('standard')" [class.is-disabled]="!pickedUserId">
            <span class="tile-chip"><nb-icon icon="file-text-outline"></nb-icon></span>
            <span class="tile-title">{{ 'cv.hub.standard' | translate }}</span>
            <span class="tile-sub">{{ 'cv.hub.standardSub' | translate }}</span>
          </button>
        }
        <button class="cv-hub-tile tile-tailored" type="button" (click)="pick('tailored')" [class.is-disabled]="!pickedUserId">
          <span class="tile-ai">{{ 'cv.hub.aiBadge' | translate }}</span>
          <span class="tile-chip"><nb-icon icon="flash-outline"></nb-icon></span>
          <span class="tile-title">{{ 'cv.hub.tailored' | translate }}</span>
          <span class="tile-sub">{{ 'cv.hub.tailoredSub' | translate }}</span>
        </button>
        <button class="cv-hub-tile tile-letter" type="button" (click)="pick('letter')" [class.is-disabled]="!pickedUserId">
          <span class="tile-ai">{{ 'cv.hub.aiBadge' | translate }}</span>
          <span class="tile-chip"><nb-icon icon="email-outline"></nb-icon></span>
          <span class="tile-title">{{ 'cv.hub.letter' | translate }}</span>
          <span class="tile-sub">{{ 'cv.hub.letterSub' | translate }}</span>
        </button>
        <button class="cv-hub-tile tile-both" type="button" (click)="pick('both')" [class.is-disabled]="!pickedUserId">
          <span class="tile-ai">{{ 'cv.hub.aiBadge' | translate }}</span>
          <span class="tile-chip"><nb-icon icon="layers-outline"></nb-icon></span>
          <span class="tile-title">{{ 'cv.hub.both' | translate }}</span>
          <span class="tile-sub">{{ 'cv.hub.bothSub' | translate }}</span>
        </button>
      </div>
    } @else {
      <bst-cv-generate-panel
        [userId]="safePickedUserId"
        [clientId]="clientId"
        (closed)="close()"
        (generated)="onGenerated($event)">
      </bst-cv-generate-panel>
    }
  </nb-card-body>
</nb-card>

<ng-template #userlisttemplate let-result="result">
  <nb-user color="#eee" [name]="result.name" [picture]="userLogo(result)" size="small"></nb-user>
</ng-template>
